import {
  Box,
  Button,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import { red } from "@mui/material/colors";
import { ArcElement, Chart as ChartJS, Legend, Tooltip } from "chart.js";
import { useEffect, useState } from "react";
import { Pie } from "react-chartjs-2";
import { moodScoreValues } from "../utils/constants";
import {
  MoodScoreResponse,
  Percentage,
  baseURL,
  isSameDate,
} from "../utils/helper";

ChartJS.register(ArcElement, Tooltip, Legend);

interface Props {
  user: any;
}

function MoodScore(props: Props) {
  const userDetails = JSON.parse(localStorage?.getItem("user") as any);
  const [isMoodScoreVisible, setIsMoodScoreVisible] = useState(false);
  const [moodScoreValue, setMoodScoreValue] = useState(100);
  const [percentageData, setPercentageData] = useState<Percentage[]>([]);
  const data = {
    labels:
      percentageData?.length > 0
        ? percentageData?.map((data) => data?.answer_value)
        : [],
    datasets: [
      {
        label: "Total Percent",
        data:
          percentageData?.length > 0
            ? percentageData?.map((data) => data?.percentage)
            : [],
        backgroundColor: [
          "#8067dc",
          "#a267db",
          "#c667db",
          "#67b7dc",
          "#6894dd",
          "#6671db",
        ],
        borderColor: ["white"],
        borderWidth: 1,
      },
    ],
  };

  async function getMoodScore() {
    const moodScoreRequest = await fetch(
      `${baseURL}/getAnswers?questionId=1&empId=${userDetails?.emp_id}`
    );
    const moodScoreParsedRes: MoodScoreResponse = await moodScoreRequest.json();
    setPercentageData(moodScoreParsedRes?.percentages);
    setIsMoodScoreVisible(true);
    const sameDate = isSameDate(
      new Date(moodScoreParsedRes?.answer?.lastmodifieddate),
      new Date()
    );
    if (!sameDate) {
      setIsMoodScoreVisible(false);
    }
    if (moodScoreParsedRes?.answer?.answer_value) {
      setMoodScoreValue(
        moodScoreValues?.[moodScoreParsedRes?.answer?.answer_value]
      );
    }
  }
  useEffect(() => {
    getMoodScore();
  }, [props?.user]);
  async function updateMoodScore() {
    let tempMoodScoreValue: any = Object.keys(moodScoreValues).find(
      (key) => moodScoreValues?.[key] == moodScoreValue
    );
    let requestBody = {
      empNo: userDetails?.emp_id,
      questionId: "1",
      optionsId: "1",
      answer: tempMoodScoreValue,
    };
    const updateMoodScoreRequest = await fetch(`${baseURL}/submit`, {
      method: "POST",
      body: JSON.stringify(requestBody),
      headers: {
        "Content-Type": "application/json",
      },
    });
    const parsedRes = await updateMoodScoreRequest.text();
    if (updateMoodScoreRequest?.ok && parsedRes === "success") {
      getMoodScore();
    }
  }

  return (
    <div>
      <Box sx={{ width: "100%" }}>
        {isMoodScoreVisible ? (
          <div
            style={{
              width: "100%",
              height: 300,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Pie
              data={data}
              options={{
                plugins: {
                  legend: {
                    position: "bottom",
                    align: "center",
                    labels: {
                      boxWidth: 10,
                      font: {
                        size: 10,
                      },
                    },
                  },
                },
              }}
            />
            <Typography
              variant="caption"
              style={{ color: "white", marginTop: 10 }}
            >
              Thank you for submitting your mood score!
            </Typography>
          </div>
        ) : (
          <>
            <Typography
              style={{ color: "white", fontSize: 16, marginBottom: 30 }}
            >
              How was your Josh today?
            </Typography>
            <form
              key={"form-moodscore"}
              onSubmit={(event) => {
                event.preventDefault();
                updateMoodScore();
              }}
              id="myForm"
            >
              <RadioGroup
                aria-labelledby="demo-controlled-radio-buttons-group"
                name={"test"}
                value={moodScoreValue}
                onChange={(e: any) => {
                  setMoodScoreValue(e.target.value);
                }}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 15,
                  flexDirection: "row",
                  justifyContent: "space-around",
                }}
              >
                {Object.keys(moodScoreValues)?.map((mood) => (
                  <div
                    key={mood}
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    <img
                      src={`${mood}.png`}
                      style={{ height: 35, width: 35 }}
                    />
                    <FormControlLabel
                      value={moodScoreValues[mood]}
                      style={{ margin: 0 }}
                      control={
                        <Radio
                          color="default"
                          sx={{
                            color: red[800],
                            "&.Mui-checked": {
                              color: red[600],
                            },
                          }}
                        />
                      }
                      label={""}
                    />
                  </div>
                ))}
              </RadioGroup>
              <Button
                type="submit"
                variant="contained"
                style={{
                  textTransform: "none",
                  color: "rgb(26, 32, 44)",
                  backgroundColor: userDetails === null ? "grey" : "white",
                  marginTop: 15,
                }}
                disabled={userDetails === null ? true : false}
              >
                Submit
              </Button>
            </form>
          </>
        )}
      </Box>
    </div>
  );
}

export default MoodScore;
